import { render } from "./ChannelFormDrawer.vue?vue&type=template&id=134a0dfa&scoped=true"
import script from "./ChannelFormDrawer.vue?vue&type=script&lang=js"
export * from "./ChannelFormDrawer.vue?vue&type=script&lang=js"

import "./ChannelFormDrawer.vue?vue&type=style&index=0&id=134a0dfa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-134a0dfa"]])

export default __exports__